import { dialogService, toastService } from '@thefarmersfront/kitchen';

import { ExcelUploadModal } from '~/components/common';

import { usePostOrdersUpload } from '~/hooks/delivery-agency/api';

import { DELIVERY_AGENCY, FILE_SIZE_LIMIT, TOAST_MESSAGE } from '~/constants';

import type { TypeDeliveryAgencyOrdersUploadResult } from '~/types/delivery-agency.types';

const infoTexts = [
  '엑셀 파일 최대 용량은 10MB입니다. 초과할 시 등록에 실패할 수 있습니다.',
  '최대 10초 정도 소요되니 완료 전까지 브라우저를 종료하지 말아주세요.',
  '1개의 주문을 2개 이상의 엑셀 파일에 나눠서 등록하지 말아주세요.',
  '22시부터 00시까지는 주문 등록이 불가합니다.',
];

const DeliveryAgencyOrderExcelUploadModal = ({
  open,
  onCancel,
  onConfirm,
}: {
  open: boolean;
  onCancel: () => void;
  onConfirm: (data: TypeDeliveryAgencyOrdersUploadResult) => void;
}) => {
  const { requestOrdersUpload } = usePostOrdersUpload();

  const handleConfirm = (file: File) => {
    if (FILE_SIZE_LIMIT < file.size) {
      dialogService.addDialog({
        children: '10MB 이하 파일만 첨부할 수 있습니다.',
      });
      return;
    }

    requestOrdersUpload(
      { file },
      {
        onSuccess: (data) => {
          onConfirm(data);
        },
        onError: (error) => {
          if (error?.code === DELIVERY_AGENCY.BACKEND_ERROR_DIALOG_CODE) {
            dialogService.addDialog({
              children: error?.message,
            });
            return;
          }
          toastService.addToast({ type: 'error', message: error?.message || TOAST_MESSAGE.DEFAULT_ERROR });
        },
      }
    );
  };

  return (
    <ExcelUploadModal
      title="주문 엑셀 일괄 등록"
      infoTexts={infoTexts}
      open={open}
      onCancel={onCancel}
      onConfirm={handleConfirm}
    />
  );
};

export default DeliveryAgencyOrderExcelUploadModal;
